import CuttingPackagesList from 'components/cuttingPackagesList/CuttingPackagesList';
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setHomePageEmployeeCutting } from 'services/store/actions/view';
import StorageTab from './StorageTab';

const CuttingEmployeeView = ({ cuttingPackages }) => {
  const dispatch = useDispatch();
  const key = useSelector((state) => state.view.homePageEmployeeCutting);

  const handleTab = (k) => {
    dispatch(setHomePageEmployeeCutting(k));
  };

  return (
    <div>
      <Tabs activeKey={key} onSelect={handleTab} className="mb-3">
        <Tab eventKey="packages" title="Pakiety cięcia">
          {key === 'packages' && (
            <CuttingPackagesList packages={cuttingPackages} />
          )}
        </Tab>
        <Tab eventKey="storage" title="Magazyn">
          {key === 'storage' && <StorageTab />}
        </Tab>
      </Tabs>
    </div>
  );
};

export default CuttingEmployeeView;
